export class Cotizacion {
    public idCotizacion: number;
    public fechaCotizacion: Date;
    public fechaActualizacion: Date;
    public fechaAceptacion: Date;
    public status: string;
    public total: number;
    public totalRef: number;
    public totalRep: number;
    public idValuacion: number;
    public tipoUnidad: string;
    public marca: string;
    public modelo: string;
    public serie: string;
    public valorComercial: number;
    public desbloquea: string;
    public fechaDesbloqueo: Date;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/cotizacion.ts